import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject , Observable, Subject} from 'rxjs';
import { AppConfig } from './constants';

@Injectable()
export class GeneralService {
  token: any;
  userId: any;
  options: any;
  // textPage: any = null;
  public textPage: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private apiUrl = this.appConfig.API_URL_PROD;
  private apiUrWeb = this.appConfig.API_URL_WEB;

  private headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

  tokenActive: Observable<boolean>;
  private tokenActSubject: Subject<boolean>;

  myBool$: Observable<string>;
  private boolSubject: Subject<string>;

  myNotice$: Observable<string>;
  gral$: Observable<string>;
  private boolNotice: Subject<string>;
  private boolGral: Subject<string>;

  constructor(public http: HttpClient, private appConfig: AppConfig) {
    this.boolSubject = new Subject<string>();
    this.myBool$ = this.boolSubject.asObservable();

    this.boolNotice = new Subject<string>();
    this.boolGral = new Subject<string>();
    this.myNotice$ = this.boolNotice.asObservable();
    this.gral$ = this.boolGral.asObservable();


    this.tokenActSubject = new Subject<boolean>();
    this.tokenActive = this.tokenActSubject.asObservable();
  }


  /*
  createHeader(token) {
    this.headers = {headers: new HttpHeaders({ 'Content-Type': 'application/json', 'token': token })};
  }*/


  createHeader(tmpToken : any ) {

    let token = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    this.headers = {headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    })};// , 'token': token
  }



  changeTextHead(ev){
    console.log(ev);
    this.boolSubject.next(ev);
    if(ev == 'ADMINAUTHTIT' || ev == 'AUTHCENTERCOST' || ev == 'PROVIDERSCAT' || ev == 'USERS'){
      this.boolGral.next('true');
    }else{
      this.boolGral.next('false');
    }
    if(ev == "NOTICE"){
      this.boolNotice.next('true');
    }else{
      this.boolNotice.next('false');
    }
  }

  actDeacUser(ev){
    this.tokenActSubject.next(ev);
  }

  typeChange(currency){
    return new Promise((resolve, reject) => {
      this.http.get('https://forex.1forge.com/1.0.3/convert?from='+currency+'&to=MXN&quantity=1&api_key=RA61YhRGvLH88kfdxFIN1quUIY8Iqx1L', this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getPostalCode(cp) {
    return new Promise((resolve, reject) => {
      this.http.get('https://api-codigos-postales.herokuapp.com/v2/codigo_postal/'+cp).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getRandom(len) {
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'random-password/'+len).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getProfiles(token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Perfiles', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  exportToExcel(uuid, token){
    this.createHeader(token);

    return new Promise((resolve, reject) => {
      let url_api = "http://67.205.93.24:10001/api/archivosCFDI?UUID="+uuid;
      this.http.get(url_api, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  validateRfc(params,token){
    const headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'token': token })};
    return new Promise((resolve, reject) => {
      this.http.post("https://proveedores-api.concent.com.mx/app.php/api/v1/validate/rfc", params, headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getNotice(token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Comunicados', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  addNotice(params,token){
    const headers = {headers: new HttpHeaders({ 'Content-Type': 'application/json', 'token': token })};

    this.createHeader(token);

    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrWeb+"Comunicados", params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getSingleNote(id, token){

    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Comunicados/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  updateNote(id, params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrWeb+'Comunicados/'+id, params ,this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getPoliticas(token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'AvisoPrivacidad', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  deleteNotice(id, token){

    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrWeb+'Comunicados/'+id+'/borrar',{}, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

}
